import { useLang } from '@/context/LanguageContext';
import { cn } from '@/lib/utils';

const OPTIONS = [
  { code: 'pl', label: 'PL' },
  { code: 'en', label: 'EN' },
  { code: 'vi', label: 'VI' },
];

// Compact segmented PL | EN | VI control. Matches the app's navy/cyan brand system and
// is safe to place in headers, onboarding/auth screens and Settings.
export const LanguageToggle = ({ className, size = 'sm' }) => {
  const { lang, setLang, t } = useLang();
  const pad = size === 'sm' ? 'px-2.5 py-1 text-[11px]' : 'px-3 py-1.5 text-xs';

  return (
    <div
      role="group"
      aria-label={t('language.switch')}
      data-testid="language-toggle"
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full border border-brand-blue/20 bg-white/[0.05] p-0.5',
        className
      )}
    >
      {OPTIONS.map(({ code, label }) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            data-testid={`language-toggle-${code}`}
            aria-pressed={active}
            onClick={() => setLang(code)}
            className={cn(
              'rounded-full font-semibold transition-colors',
              pad,
              active
                ? 'bg-brand-cyan text-brand-ink shadow-[var(--glow-brand)]'
                : 'text-foreground/55 hover:text-foreground/85'
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
